<template>
 <div class="assess-parent">
   <div class="assess-box">
    <div class="assess-item">
       <div class="assess-top">
            <p class="assess-title">
                <svg t="1501817435013" class="icon" style="" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3520" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><defs></defs><path d="M613.52579 105.902982c-168.205956 0-304.575834 136.37704-304.575834 304.575834 0 51.429323 12.865006 99.813287 35.393091 142.320403L132.567783 764.523317l0.176009 0.179079c-16.533558 16.256242-26.843368 38.811957-26.843368 63.822584 0 49.471738 40.105417 89.572038 89.577155 89.572038 25.010627 0 47.566342-10.30981 63.824631-26.839275l-0.049119-0.050142 211.697493-211.67498c42.534745 22.604834 91.01797 35.518958 142.575206 35.518958 168.195723 0 304.573787-136.376017 304.573787-304.572764C918.098553 242.278999 781.721513 105.902982 613.52579 105.902982L613.52579 105.902982zM227.601206 859.529111c-8.178263 8.450463-19.48068 13.780865-32.123628 13.780865-24.736381 0-44.786019-20.050662-44.786019-44.790112 0-12.637832 5.326309-23.941272 13.780865-32.121582l-0.226151-0.197498 204.737988-204.733894c17.892509 24.140817 39.207977 45.454238 63.301721 63.402005L227.601206 859.529111 227.601206 859.529111zM613.52579 664.285359c-140.16839 0-253.813706-113.644293-253.813706-253.806543 0-140.16839 113.645316-253.812683 253.813706-253.812683 140.167367 0 253.81166 113.644293 253.81166 253.812683C867.337449 550.641065 753.692133 664.285359 613.52579 664.285359L613.52579 664.285359zM613.52579 232.810347c-98.130971 0-177.670515 79.537498-177.670515 177.668469 0 7.013741 5.674233 12.687974 12.68695 12.687974 7.015787 0 12.694113-5.67321 12.694113-12.687974 0-84.102467 68.184939-152.287405 152.288428-152.287405 7.013741 0 12.68695-5.674233 12.68695-12.69309C626.21274 238.483556 620.538507 232.810347 613.52579 232.810347L613.52579 232.810347zM613.52579 232.810347" p-id="3521" fill="#ffffff"></path></svg>
                <span>快速评估</span>
            </p>
            <div class="assess-form">
                <el-form ref="form" :model="form">
                    <el-cascader
                        :options="carOptions"
                        @active-item-change="handleItemChange"
                        :props="props"
                        placeholder="请选择品牌车型"
                        filterable
                        @change="handleCarChange"
                        ></el-cascader>

                    <el-date-picker
                        v-model="form.date"
                        type="month"
                        placeholder="请选择上牌日期"
                        @change="handleDateChange"
                        >
                    </el-date-picker>

                    <el-input class="mil" placeholder="请输入里程" v-model="form.mileage"></el-input>
                </el-form>
                <div class='assess-quick'>
                    <div>
                        <span class='assess-num'>{{assessNum}}</span> 元
                    </div>
                    <el-button type="danger" @click='handleAssessClick'>快速评估</el-button>
                </div>
            </div>
       </div>
       <div class="assess-foot">
           <div class='assess-foot-item'>
              <h1>{{quickNum}}</h1>
              <p>快速评估次数</p>
           </div>
           <div class='assess-foot-item'>
              <h1>{{exactNum}}</h1>
              <p>精准评估次数</p>
           </div>
       </div>
    </div>  
   </div>
   </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        date: '',
        mileage: '',
        category_3: ''
      },
      carOptions: [],
      carOptions2: [],
      carOptions3: [],
      props: {
        value: 'name',
        children: 'child'
      },
      default: {
        assessNum: 0,
        exactNum: 0,
        quickNum: 0,
      },
      state: {
        currentStep: 0,
        originalValue: 0,
        originalValue2: 0,
        originalValue3: 0,
        assessNum: 0,
        exactNum: 0,
        quickNum: 0
      },
      steps: 10
    }
  },
  computed: {
    assessNum () {
      let value = Math.round(this.state.assessNum)
      return this.commas(value)
    },
    exactNum () {
      let value = Math.round(this.state.exactNum)
      return this.commas(value)
    },
    quickNum () {
      let value = Math.round(this.state.quickNum)
      return this.commas(value)
    }
  },
  methods: {
    fetch () {
      this.$http.get('https://api-test.la-feng.com/open/scalar').then(res => {
        // console.log(res)
        // this.default.targetValue1 = res.body.data.incar_dealer_num
        this.default.exactNum = res.body.data.car_num
        // this.default.targetValue3 = res.body.data.car_total_price
        this.setValue()
      })
      this.$http.get('https://api-test.la-feng.com/cars/generate-amount').then(res => {
        this.default.quickNum = res.body.data.amount
        this.setValue()
        // console.log(res)
      })
    },
    setValue () {
      this.state.currentStep = 0
      clearInterval(time)
      let time = setInterval(() => {
        if (this.state.currentStep >= this.steps) {
          clearInterval(time)
        }
        this.state.assessNum = this.increase(this.state.currentStep / this.steps, this.default.assessNum, this.state.originalValue)
        this.state.exactNum = this.increase(this.state.currentStep / this.steps, this.default.exactNum, this.state.originalValue2)
        this.state.quickNum = this.increase(this.state.currentStep / this.steps, this.default.quickNum, this.state.originalValue3)
        this.state.currentStep = this.state.currentStep + 1
        this.state.originalValue = this.state.assessNum
        this.state.originalValue2 = this.state.exactNum
        this.state.originalValue3 = this.state.quickNum
      }, 500 / this.steps)
    },
    increase (percent, targetValue, originalValue) {
      const diff = targetValue - originalValue
      return (diff * percent) + originalValue
    },
    commas (val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    change (arr) {
      arr.forEach(item => {
        item.child = []
        item.label = item.name
      })
    },
    change2 (arr) {
      arr.forEach(item => {
        item.label = item.name
      })
    },
    getId (arr, val) {
      let id
      arr.forEach(item => {
        if (item.name === val) {
          id = item.id
        }
      })
      return id
    },
    getAutoId (arr, val) {
      let id
      arr.forEach(item => {
        if (item.name === val) {
          id = item.auto_id
        }
      })
      return id
    },
    handleItemChange (item) {
    //   console.log(item)
      let id = this.getId(this.carOptions, item[0])
      let cid = this.getId(this.carOptions2, item[1])
    //   console.log('fid: ' + id)
    //   console.log('cid: ' + cid)
      if (!cid) {
        this.$http.get(`https://api-test.la-feng.com/cars/car-category?level=1&value=${item[0]}`).then(res => {
            if (res.body.data && res.body.data.length > 0) {
            this.change(res.body.data)
            this.carOptions2 = res.body.data
            this.carOptions[id -1].child = res.body.data
            } else {
            }
        })
      } else {
        this.getCar(cid, item, id)
      }
    },
    getCar (cid, item, id) {
      this.$http.get(`https://api-test.la-feng.com/cars/car-category?level=2&value=${item[1]}`).then(res => {
        if (res.body.data.length > 0) {
          this.change2(res.body.data)
          this.carOptions3 = res.body.data
          this.carOptions[id -1].child[cid - 1].child = res.body.data
        } else {
        }
      })
    },
    handleCarChange (val) {
      if (val.length === 3 && this.carOptions3.length > 0) {
        this.form.category_3 = this.getAutoId(this.carOptions3, val[2])
      }
    },
    handleAssessClick () {
      if (this.form.date && this.form.category_3) {
        if (this.form.mileage) {
          this.$http.get(`https://api-test.la-feng.com/cars/assess?category_3=${this.form.category_3}&date=${this.form.date}&mileage=${this.form.mileage}`).then(res => {
            if (res.body.code === 0) {
              this.default.assessNum = res.body.data.price
              this.setValue()
              this.fetch()
            }
          })
        }
      }
    },
    handleDateChange (val) {
      console.log(val)
      this.form.date = val
    }
  },
  created () {
    this.$http.get('https://api-test.la-feng.com/cars/car-category').then(res => {
      if (res.body.code === 0) {
        this.change(res.body.data)
        this.carOptions = res.body.data
        // console.log(this.carOptions)
      }
    })
    this.fetch()
  }
}
</script>

<style lang='scss' scoped>
  .assess-parent {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    .assess-box {
      width: 77%;
      min-width: 1088px;
      height: 100%;
      margin: 0 auto;
      position: relative;
    }
  }

  .assess-item {
     position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 340px;
      height: 500px;
      background: rgba(44 , 64, 106, .4);
      text-align: center;
      .assess-top {
          height: 380px;
          padding-top: 100px;
          .assess-title {
              color: #fff;
              margin-top: -100px;
              height: 100px;
              line-height: 100px;
              font-size: 28px;
              svg {
                width: 35px;
                height: 35px;
                vertical-align: middle;
              }
              span {
                  vertical-align: middle;
                  margin-left: -5px;
              }
          }
          .assess-form {
              height: 100%;
              width: 80%;
              margin: 0 auto;
              .el-input, .el-cascader {
                  width: 100%;
              }
              .el-form {
                height: 160px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              }
              .mil {
                  &::after {
                      content: '公里';
                      display: inline-block;
                      position: absolute;
                      right: 10px;
                      top: 10px;
                      font-size: 14px;
                  }
              }
          }
          .assess-quick {
              height: 120px;
              display: flex;
              color: #fff;
              justify-content: space-between;
              align-items: center;
              font-size: 18px;
              font-weight: 500;
              .assess-num {
                  display: inline-block;
                  width: 150px;
                  height: 36px;
                  border-bottom: 1px solid #fff;
                  font-size: 28px;
                  padding: 0 10px;
                  color: #fff;
              }
              .el-button {
                padding: 12px 10px;
              }
          }
      }
      .assess-foot {
          background: #fff;
          height: 120px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          p {
              color: #778490;
              font-size: 14px;
          }
          h1 {
              color: #ff3b30;
              margin-bottom: 3px;
              font-size: 26px;
          }
          .assess-foot-item {
              width: 50%;
              height: 80%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              &:first-child{
                border-right: 1px solid #e5e5e5;
              }
          }
      }
  }
</style>



// WEBPACK FOOTER //
// assessItem.vue?6079a73c